import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import Slider from 'react-slick';
import useTranslations from '@hooks/useTranslation';
import { COMPONENT_TYPE, IColors, IConferenceItem } from '../../interfaces/Conference';
import { breakpoints } from '../../styles/theme';
import {
    Author,
    CarouselWrapper,
    Company,
    Description,
    LegislativeLabel,
    Reference,
    Title,
    TitleSymbol,
    Wrapper,
} from './ConferenceReferences.elements';

interface ConferenceProps {
    colors?: IColors;
    conf?: IConferenceItem;
}

const ConferenceReferencesTemplate: FC<ConferenceProps> = ({ colors, conf }) => {
    const { t } = useTranslations();

    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        responsive: [
            {
                breakpoint: breakpoints.xs,
                settings: { slidesToShow: 1, dots: true },
            },
            {
                breakpoint: breakpoints.sm,
                settings: { slidesToShow: 2, dots: true },
            },
            {
                breakpoint: breakpoints.md,
                settings: { slidesToShow: 3, dots: true },
            },
        ],
    };
    return (
        <Wrapper id={`confSection${COMPONENT_TYPE.REFERENCES}`} colors={colors}>
            {conf?.conference?.references.length > 0 && (
                <>
                    <Title colors={colors}>
                        {t('conference.component.references.title')}
                        <TitleSymbol colors={colors} />
                    </Title>

                    <CarouselWrapper>
                        <Slider {...settings}>
                            {conf?.conference?.references.map((item, index) => (
                                <Reference colors={colors} key={`${index}`}>
                                    <Description>{item.name}</Description>
                                    <Author>{item.author}</Author>
                                    <Company>{item.company}</Company>
                                </Reference>
                            ))}
                        </Slider>
                    </CarouselWrapper>

                    <LegislativeLabel>{t('conference.component.references.origin')}</LegislativeLabel>
                </>
            )}
        </Wrapper>
    );
};

export default ConferenceReferencesTemplate;
